var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('user_list',{attrs:{"UserListData":_vm.UserListData,"handleState":"3"},on:{"refresh":function($event){return _vm.getList()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }